import { useState } from 'react';
import { FileJson, FlaskConical, Upload } from 'lucide-react';

type FileDropzoneProps = {
  disabled?: boolean;
  onFile: (file: File) => void;
  onSample: (kind: 'day' | 'trip' | 'noise' | 'unknown') => void;
};

export function FileDropzone({ disabled = false, onFile, onSample }: FileDropzoneProps) {
  const [dragging, setDragging] = useState(false);

  const handleFiles = (files: FileList | null) => {
    const file = files?.[0];
    if (file && !disabled) onFile(file);
  };

  return (
    <div className="section">
      <label
        className={`dropzone${dragging ? ' dragging' : ''}`}
        onDragEnter={(event) => {
          event.preventDefault();
          setDragging(true);
        }}
        onDragOver={(event) => event.preventDefault()}
        onDragLeave={() => setDragging(false)}
        onDrop={(event) => {
          event.preventDefault();
          setDragging(false);
          handleFiles(event.dataTransfer.files);
        }}
      >
        <input
          type="file"
          accept=".json,application/json"
          disabled={disabled}
          onChange={(event) => handleFiles(event.target.files)}
          aria-label="location-history.json を選択"
        />
        <div className="dropzone-content">
          <FileJson size={34} aria-hidden="true" />
          <div>
            <h2 className="dropzone-title">location-history.json</h2>
            <p className="dropzone-copy">iOS / Android の Timeline data export、または Google Takeout の Location History JSON に対応します。</p>
          </div>
          <span className="button primary">
            <Upload size={17} aria-hidden="true" />
            ファイルを選択
          </span>
        </div>
      </label>

      <div className="button-row" aria-label="サンプルデータ">
        <button className="button" type="button" disabled={disabled} onClick={() => onSample('trip')}>
          <FlaskConical size={16} aria-hidden="true" />
          東京→大阪サンプル
        </button>
        <button className="button" type="button" disabled={disabled} onClick={() => onSample('day')}>
          <FlaskConical size={16} aria-hidden="true" />
          東京1日サンプル
        </button>
        <button className="button" type="button" disabled={disabled} onClick={() => onSample('noise')}>
          <FlaskConical size={16} aria-hidden="true" />
          ノイズ入り
        </button>
        <button className="button" type="button" disabled={disabled} onClick={() => onSample('unknown')}>
          <FlaskConical size={16} aria-hidden="true" />
          未対応形式
        </button>
      </div>
    </div>
  );
}
